import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetErfinaProductDetailResponseDto } from "../../dtos/erfina-product-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetErfinaProductDetailQueryProps = {
  productId: string;
  options?: Omit<
    UseQueryOptions<GetErfinaProductDetailResponseDto>,
    "queryKey"
  >;
};

export const useGetErfinaProductDetailQuery = ({
  productId,
  options
}: UseGetErfinaProductDetailQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getErfinaProductDetail({ productId }).queryKey,
    queryFn: async () =>
      await ProductService.getErfinaProductDetail({
        payload: { productId }
      }),
    ...options
  });
};
